import {
    Action,
    combineReducers,
    configureStore,
    ThunkAction,
} from '@reduxjs/toolkit';
import applianceReducer from './applianceSlice';
import locationApaleoPropertyReducer from './locationApaleoPropertySlice';
import locationsReducer from './locationsSlice';
import serialNumbersReducer from './serialNumbersSlice';
import turnoverReducer from './turnoverSlice';
import countriesDetailsReducer from './countriesDetailsSlice';
import partnerContactsReducer from './partnerContactsSlice';
import usageDataReducer from './usageDataSlice';
import mansionsReducer from './mansionsSlice';
import userDetailsReducer from './userDetailsSlice';
import accountingAreaDefaultsReducer from './accountingAreaDefaultsSlice';
import objectStatsReducer from './objectStatsSlice';
import registrationReducer from './registrationSlice';
import genericSettingsReducer from './genericSettingsSlice';
import oauthReducer from './propertyLinkSlice';
import authReducer, { FULL_RESET, getAuthPreload } from './authSlice';
import partnerManagerReducer, {
    getPartnerManagerPreload,
} from './partnerManagerSlice';
import userReducer from './userSlice';
import passwordResetReducer from './passwordResetSlice';
import changeEmailReducer from './changeEmailSlice';
import loginManagerActivationReducer from './loginManagerActivationSlice';
import vipUsersReducer from './vipUsersSlice';
import locationCostsReducer from './locationCostsSlice';
import accountingAreaRolesReducer from './accountingAreaRolesSlice';
import partnerInvoiceReducer from './partnerInvoiceSlice';
import operationalContactsReducer from './operationalContactsSlice';
import installationLinkReducer from './installationLinkSlice';
import { pbRequestReducer } from './pbRequestSlice';

const reducer = combineReducers({
    pbRequest: pbRequestReducer,
    accountingAreaDefaults: accountingAreaDefaultsReducer,
    appliance: applianceReducer,
    serialNumbers: serialNumbersReducer,
    turnover: turnoverReducer,
    partnerInvoice: partnerInvoiceReducer,
    countriesDetails: countriesDetailsReducer,
    partnerContacts: partnerContactsReducer,
    locations: locationsReducer,
    locationApaleoProperty: locationApaleoPropertyReducer,
    usageData: usageDataReducer,
    userDetails: userDetailsReducer,
    mansions: mansionsReducer,
    objectStats: objectStatsReducer,
    registration: registrationReducer,
    genericSettings: genericSettingsReducer,
    propertyOAuthLink: oauthReducer,
    auth: authReducer,
    partnerManager: partnerManagerReducer,
    user: userReducer,
    passwordReset: passwordResetReducer,
    changeEmail: changeEmailReducer,
    loginManagerActivation: loginManagerActivationReducer,
    vipUsers: vipUsersReducer,
    locationCosts: locationCostsReducer,
    accountingAreaRoles: accountingAreaRolesReducer,
    operationalContacts: operationalContactsReducer,
    installationLink: installationLinkReducer,
});

type RootReducerType = typeof reducer;

const reducerProxy: RootReducerType = (state, action) => {
    if (action.type === FULL_RESET) {
        return reducer(undefined, action);
    }
    return reducer(state, action);
};

const store = configureStore({
    reducer: reducerProxy,
    preloadedState: {
        auth: getAuthPreload(),
        partnerManager: getPartnerManagerPreload(),
    },
});

export type RootState = ReturnType<typeof store.getState>;

export type PbDispatch = typeof store.dispatch;
export type PbGetState = () => RootState;
export type PbThunk = ThunkAction<void, RootState, null, Action<string>>;

export default store;
